export default __webpack_public_path__ + "static/media/flg_sa.8c4e8922.svg";